import React from 'react';
import { useTranslations } from 'next-intl';
function NoDataFound() {
  const t = useTranslations('category');
  return (
    <div className='my-12 flex flex-col items-center justify-center text-center'>
      <h3 className='text-primary text-lg font-medium'>
        {t('no_products_found')}
      </h3>
      <p className='mt-2 text-sm text-gray-500'>{t('try_adjusting_filters')}</p>
    </div>
  );
}

export default NoDataFound;
